angular.module('impactx.workspace').component('ixWorkspaceSwitch', {
        controller: 'WorkspaceSwitchCtrl',
        templateUrl: 'shared/workspace/templates/workspace-switch.html'
    }
);